import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { GetBoxDetailsInput, GetBoxDetailsOutput } from "types/web-app";

export const getBoxDetails = async (
  accessToken: string,
  input: GetBoxDetailsInput
) => {
  try {
    const response = await fetchWithAuth(`/box/details?box_id=${input.box_id}`, accessToken, {
      method: "GET",
    });
    const data = (await response.json()) as ServiceResponse<GetBoxDetailsOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
